import apiClient from './client';
import { ActorReleaseResponseMessage } from '@/types/ActorReleaseResponse';

/**
 * Permanently deletes the current actor account.
 */
export async function writeActorRelease(): Promise<ActorReleaseResponseMessage> {
  const response = await apiClient.post<ActorReleaseResponseMessage>(
      '/secure/actor/release');
  return response.data;
}
